import React, { ReactElement, useEffect } from 'react';
import { Form } from 'formik';
import { roofTypesOptions } from '../../../../data/enumerations';
import { useDataCollection } from '../../../../hooks';
import { InjectedWizardStepProps } from '../../../components/Steps/WizardStep';
import StepHeader from '../../../components/Layout/StepHeader';
import CheckCard from '../../../components/Form/CheckCard';

const StepRoofType = ({ completeStep }: InjectedWizardStepProps): ReactElement<'div'> | null => {
    const { handleChange, values } = useDataCollection();

    useEffect(() => {
        if (values.roofType) {
            completeStep && completeStep(true);
        }
    }, [values, completeStep]);

    return (
        <Form>
            <StepHeader title="Jaký máte typ střechy?" />
            <div className={'wiz-card wiz-card--small'}>
                <div className={'wiz-card__inner'}>
                    {roofTypesOptions.map(({ value, title, img }, index) => {
                        return (
                            <div key={`rft-${index}`} className={'wiz-card-item'}>
                                <CheckCard
                                    name={'roofType'}
                                    onChange={handleChange}
                                    checked={values.roofType === value}
                                    value={value}
                                >
                                    <div className={'check-card__inner'}>
                                        <div className={'check-card__image'}>
                                            <img src={img} alt="" />
                                        </div>
                                        <div className="check-card__text">
                                            <h3>{title}</h3>
                                            {/* <p>{option.description}</p> */}
                                        </div>
                                    </div>
                                </CheckCard>
                            </div>
                        );
                    })}
                </div>
            </div>
        </Form>
    );
};

export default StepRoofType;
